export default __webpack_public_path__ + "static/media/Mercenary's Boots of the Roaring Jungle.2e2f9727.jpg";